/*
 *		Copyright (c) 2011-2016	Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.DataTable')
    .directive('accSearch', ['SearchService', 'template', function (SearchService, template) {
        return {
            scope: {},
            replace: true,
            templateUrl: template('nodes/_search_box'),
            link: function($scope, $element) {
                var focused = false;
                $scope.searchState = SearchService.searchState;
                $scope.extended = false;
                
                $scope.$watch('searchState.string', function(newVal) {
                    if (!focused && newVal === '') {
                        $scope.extended = false;
                    }
                });
                
                $scope.$watch('searchState.enabled', function(enabled) {
                   if (!enabled) {
                       $scope.searchState.string = '';
                       $scope.extended = false;
                   }
                });
                
                $scope.search = function() {
                    if ($scope.searchState.string) {
                        SearchService.search();
                    } else {
                        $scope.focusInput();
                    }
                };
                
                $scope.resetSearch = function() {
                    SearchService.resetSearch();
                    $scope.focusInput();
                };
                
                $scope.extend = function() {
                    focused = true;
                    $scope.extended = true;
                };
                
                $scope.shrink = function(e) {
                    focused = false;
                    
                    if ($scope.searchState.string) return;
    
                    switch(e.relatedTarget && e.relatedTarget.id) {
                        case 'search-button':
                        case 'reset-button':
                            $scope.focusInput();
                            break;
                        default:
                            $scope.extended = false;
                    }
                };
                
                $scope.focusInput = function() {
                    $element.find('input').focus();
                }
            }
        };
    }]);
